import type { GForm } from '@Types/GF/form';

import { useState } from 'react';

import parse from 'html-react-parser';

import apiFetch from '@wordpress/api-fetch';

import type { Decorations } from '@/_types/Shared/Button';
import { ArrowBig, ArrowSmall, ValidationIcon } from '@/views/Shared/Icons';

import GravityFormsField from '../GF/GravityFormsField';

export default function GForm({
	form,
	form_id,
	btnHasIcon,
	btnDecorationElement,
}: {
	form?: GForm;
	form_id?: string;
	btnHasIcon?: boolean;
	btnDecorationElement?: Decorations;
}) {
	const [confirmationMessage, setConfirmationMessage] = useState<string>('');
	const [errorMessage, setErrorMessage] = useState<any>('');

	const [isValid, setIsValid] = useState<boolean>(false);
	const [formValues, setFormValues] = useState<any>({
		form_id: form_id,
		values: {},
	});

	function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();

		SubmitForm();
	}

	function SubmitForm() {
		const _posts: Promise<string> = apiFetch({
			path: `/gf/v2/forms/${form_id}/submissions`,
			method: 'POST',
			data: formValues.values,
		});

		_posts.then((req: any) => {
			if (req.is_valid) {
				setIsValid(true);
				setConfirmationMessage(req.confirmation_message);
			}
		});
		_posts.catch((req: any) => {
			setIsValid(false);
			setErrorMessage(req.validation_messages);
		});
	}

	return (
		<>
			{isValid ? (
				<div className='font-minos-form-content-font-family text-center text-base text-minos-form-content-color tablet:minos-form-content-font-style'>
					<ValidationIcon className='mx-auto mb-4 block w-fit' />
					{parse(confirmationMessage)}
				</div>
			) : (
				<form method='post' onSubmit={handleSubmit}>
					{form?.fields && (
						<div className='minos-form-content-font-style text-base tablet:minos-form-content-font-style'>
							{form?.fields.map((field) => {
								return (
									<GravityFormsField
										key={field?.id}
										field={field}
										fields={form?.fields}
										errorMessage={errorMessage}
										setFormValues={setFormValues}
										formValues={formValues}
									/>
								);
							})}
						</div>
					)}

					<button
						className={`group minos-form-submit relative inline-flex w-fit items-center gap-4 border-2 px-8 py-4 text-base transition-colors duration-500 ease-in-out tablet:minos-form-submit`}
						type='submit'
					>
						{form?.button?.text || 'Submit'}

						{btnHasIcon ? (
							<>
								{btnDecorationElement === 'long' && (
									<ArrowBig
										width='20'
										className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
									/>
								)}

								{btnDecorationElement === 'short' && (
									<ArrowSmall
										width='20'
										className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
									/>
								)}
							</>
						) : (
							''
						)}
					</button>
				</form>
			)}
		</>
	);
}
